import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import UserApi from '../../../API/user/user-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { LinkBlue } from '../../../components/Basic/Elements';
import { Content, PageTitle } from '../../../components/Basic/Global';
import { DateInput, InputLabel } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1, Text, TextGrey } from '../../../components/Basic/WrapsStyle';
import ReasonTypeWrap from '../../../components/Shipments/WrapStyle/ReasonType';
import { TO_PROFILE, TYPE_BUTTONS } from '../../../constans';
import { getDate } from '../../../utils';
import { numberWithSpaces } from '../../../utils/index';
import AddHourlyPayPopUp from './PopUps/AddHourlyPay';
import AddRetentionPopUp from './PopUps/AddRetention';
import DisputeAnswerPenaltyPopUp from './PopUps/DisputeAnswerPenalty';
import DisputePenaltyPopUp from './PopUps/DisputePenalty';
import styles from './styles.module.scss';

let MAP_FROM = {
  reserves: 'Резервы',
  postings: 'Отгрузка',
  warehouse: 'Склад',
};

export const WIDTH = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '300px', // 3
];

const STATUS_SELLAY_MAP = {
  new: 'Текущий период',
  closed: 'Оплачено',
};
const initToday = () => {
  return moment(new Date()).format('MM-DD-YYYY');
};

function PeriodFinancesPage() {
  const { userId, periodId } = useParams();
  console.log(periodId)

  let [finances, setFinances] = useState({});
  let [period, setPeriod] = useState({});
  let [openHourWindow, setOpenHourWindow] = useState(false);
  let [openRetentionWindow, setOpenRetentionWindow] = useState(false);
  let [openStornoWindow, setOpenStornoWindow] = useState({ state: false, penalty: {} });
  let [openStornoAnswerWindow, setOpenStornoAnswerWindow] = useState({ state: false, penalty: {} });

  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const user = useSelector((store) => store.user);
  const [currentUser, setCurrentUser] = useState({});
  const [images, setImages] = useState({ links: [], index: 0 });

  const [periodEnd, setPeriodEnd] = useState(new Date());
  const [statisticByDays, setStatisticByDays] = useState({});

  const [penalties, setPenalties] = useState([]);
  const [extraWork, setExtraWork] = useState([]);

  let [penaltyMap, setPenaltyMap] = useState({});

  const openImageViewer = (images, index) => {
    setImages({ links: images, index });
    setIsViewerOpen(true);
  };

  const changePenalty = async (data) => {
    const penalty = await UserApi.changePenalty({ data }).then(r => r.penalty)
    const newPens = penalties.map(p => {
      if (p._id === data.penaltyId) return penalty
      return p
    })
    setPenalties(newPens)
  }

  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages({ links: [], index: 0 });
  };

  let load = () => {
    UserApi.getFinancesByPeriod({ data: { financeId: periodId, endDate: periodEnd } }).then((r) => {
      setPeriod(r.userFinancePeriod);
      setFinances(r.userFinancePeriod === 'closed' ? r.userFinancePeriod?.salary : r.finances);

      setStatisticByDays(r.statisticByDays);
      //setPenaltiesByDays(r.statisticByDay.penaltiesByDays);
      setCurrentUser(r.user);

      setPenaltyMap({ ...r.postingsMap, ...r.reservedMap, ...r.warehouseMap });

      let p = [];
      let ex = [];

      Object.keys(r.statisticByDays)
        .map((day) => r.statisticByDays[day]?.penalty?.items)
        .filter((item) => item)
        .forEach((item) => {
          p = [...p, ...item];
        });

      setPenalties(p);
      Object.keys(r.statisticByDays)
        .map((day) => r.statisticByDays[day]?.extra_work?.items)
        .filter((item) => item)
        .forEach((item) => {
          ex = [...ex, ...item];
        });

      setExtraWork(ex);
    });
  };

  useEffect(() => {
    load();
  }, [periodId, periodEnd]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  console.log(penalties);
  return (
    <Content>
      <PageTitle title={user.name} />
      <H1 style={{ marginBottom: '5px' }}>Зарплата за период {currentUser.name}</H1>
      <LinkBlue to={TO_PROFILE(currentUser._id)} style={{ fontSize: '14px' }}>Вернуться в профиль</LinkBlue>
      <WhiteBlock style={{ marginTop: '15px', minWidth: '1615px' }}>
        <Row style={{ marginTop: '20px' }}>
          <Column>
            <Row>
              <TextGrey fontSize={'20px'}>Период: </TextGrey>{' '}
              <Text fontSize={'25px'} fontWeight={'600'}>
                {period.status === 'new' ? (
                  <>{getDate(period.period?.from)}</>
                ) : (
                  <>
                    {getDate(period.period?.from)} - {getDate(period.period?.to)}
                  </>
                )}
              </Text>
            </Row>
            <Row>
              <TextGrey fontSize={'20px'}>Статус: </TextGrey>{' '}
              <Text fontSize={'25px'} fontWeight={'600'}>
                {STATUS_SELLAY_MAP[period.status]}
              </Text>
            </Row>
            <Row>
              <TextGrey fontSize={'20px'}>Зарплата: </TextGrey>{' '}
              <Text fontSize={'25px'} fontWeight={'600'}>
                {numberWithSpaces(finances.total?.toFixed(2))} ₽
              </Text>
            </Row>
            <Row>
              <TextGrey fontSize={'20px'}>Количество разложенных заказов: </TextGrey>
              <Text fontSize={'25px'} fontWeight={'600'}>
                {numberWithSpaces(finances.pick?.count)} ({numberWithSpaces(finances.pick?.sum)} ₽)
              </Text>
            </Row>
            <Row>
              <TextGrey fontSize={'20px'}>Количество обработанных экспрессов: </TextGrey>
              <Text fontSize={'25px'} fontWeight={'600'}>
                {numberWithSpaces(finances.pick_express?.count)} ({numberWithSpaces(finances.pick_express?.sum)} ₽)
              </Text>
            </Row>
            <Row>
              <TextGrey fontSize={'20px'}>Количество упакованных заказов: </TextGrey>
              <Text fontSize={'25px'} fontWeight={'600'}>
                {finances.packaging?.count} ({numberWithSpaces(finances.packaging?.sum)} ₽)
              </Text>
            </Row>
            <Row>
              <TextGrey fontSize={'20px'}>Количество собранных резервов: </TextGrey>
              <Text fontSize={'25px'} fontWeight={'600'}>
                {finances.reserve_assembly?.count} ({numberWithSpaces(finances.reserve_assembly?.sum)} ₽)
              </Text>
            </Row>
            <Row>
              <TextGrey fontSize={'20px'}>Количество занесенных возвратов: </TextGrey>
              <Text fontSize={'25px'} fontWeight={'600'}>
                {finances.entry_return?.count} ({numberWithSpaces(finances.entry_return?.sum)} ₽)
              </Text>
            </Row>
            <Row>
              <TextGrey fontSize={'20px'}>Количество занесений с отгрузки: </TextGrey>
              <Text fontSize={'25px'} fontWeight={'600'}>
                {finances.entry_overage?.count} ({numberWithSpaces(finances.entry_overage?.sum)} ₽)
              </Text>
            </Row>
            <Row>
              <TextGrey fontSize={'20px'}>Количество занесений от поставщика: </TextGrey>
              <Text fontSize={'25px'} fontWeight={'600'}>
                {finances.entry_entrying?.count} ({numberWithSpaces(finances.entry_entrying?.sum)} ₽)
              </Text>
            </Row>
            <Row>
              <TextGrey fontSize={'20px'}>Штрафы: </TextGrey>{' '}
              <Text fontSize={'25px'} fontWeight={'600'}>
                {finances.penalty?.count} ({numberWithSpaces(finances.penalty?.sum)} ₽)
              </Text>
            </Row>
            {!currentUser.is_hourly_pay && (
              <Row>
                <TextGrey fontSize={'20px'}>Премия 5% от сделки (при отсутсвии штрафов): </TextGrey>{' '}
                <Text fontSize={'25px'} fontWeight={'600'}>
                  {numberWithSpaces(finances?.premium?.sum)} ₽
                </Text>
              </Row>
            )}
          </Column>
        </Row>
        {/*  period.status !== 'closed' */}
        {isOwner && period.status !== 'closed' && (
          <Row style={{ alignItems: 'flex-end', marginTop: '10px' }}>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Дата закрытия периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput value={periodEnd} className={styles.calendar} onChange={(v) => setPeriodEnd(new Date(v))} />
              </Row>
            </Column>
            <Button
              type={TYPE_BUTTONS.BLUE}
              onClick={() =>
                UserApi.changeFinancesPeriod({
                  data: {
                    financeId: periodId,
                    field: 'status',
                    value: {
                      status: 'closed',
                      endDate: periodEnd,
                    },
                  }
                })
              }
            >
              Закрыть период
            </Button>
          </Row>
        )}

        {true && (
          <Table styles={styles.table}>
            <TableHeader whiteHeader>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Дата
              </HeaderTitle>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Пропик
              </HeaderTitle>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Упаковка
              </HeaderTitle>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Обработка экспрессов
              </HeaderTitle>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Сборка резервов
              </HeaderTitle>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Занесение возвратов
              </HeaderTitle>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Занесение с отгрузки
              </HeaderTitle>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Занесение от поставщика
              </HeaderTitle>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Почасовая оплата
              </HeaderTitle>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Штрафы
              </HeaderTitle>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Возврат штрафов
              </HeaderTitle>
              <HeaderTitle width={WIDTH[0]} centerText={true}>
                Итого
              </HeaderTitle>
            </TableHeader>
            {Object.keys(statisticByDays)
              .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
              .map((day) => {
                const data = statisticByDays[day];
                //const data_penalty = penaltiesByDays[day];

                return (
                  <TableLine key={day}>
                    <TableCell width={WIDTH[0]} center>
                      {getDate(day)}
                    </TableCell>
                    <TableCell width={WIDTH[0]} center>
                      <Row>
                        <Text fontSize={'14px'}>{numberWithSpaces(data.pick?.count)}</Text> /
                        <Text className={styles.green} fontSize={'16px'}>
                          {' '}
                          + {numberWithSpaces(data.pick?.sum)}
                        </Text>
                      </Row>
                    </TableCell>
                    <TableCell width={WIDTH[0]} center>
                      <Row>
                        <Text fontSize={'14px'}>{numberWithSpaces(data.packaging?.count)}</Text> /
                        <Text className={styles.green_dark} fontSize={'16px'}>
                          {' '}
                          + {numberWithSpaces(data.packaging?.sum)}
                        </Text>
                      </Row>
                    </TableCell>
                      <TableCell width={WIDTH[0]} center>
                      <Row>
                        <Text fontSize={'14px'}>{numberWithSpaces(data.pick_express?.count)}</Text> /
                        <Text className={styles.green_dark} fontSize={'16px'}>
                          {' '}
                          + {numberWithSpaces(data.pick_express?.sum)}
                        </Text>
                      </Row>
                    </TableCell>
                    <TableCell width={WIDTH[0]} center>
                      <Row>
                        <Text fontSize={'14px'}>{numberWithSpaces(data.reserve_assembly?.count)}</Text> /
                        <Text className={styles.green_dark} fontSize={'16px'}>
                          {' '}
                          + {numberWithSpaces(data.reserve_assembly?.sum)}
                        </Text>
                      </Row>
                    </TableCell>
                    <TableCell width={WIDTH[0]} center>
                      <Row>
                        <Text fontSize={'14px'}>{numberWithSpaces(data.entry_return?.count)}</Text> /
                        <Text className={styles.green_dark} fontSize={'16px'}>
                          {' '}
                          + {numberWithSpaces(data.entry_return?.sum)}
                        </Text>
                      </Row>
                    </TableCell>
                    <TableCell width={WIDTH[0]} center>
                      <Row>
                        <Text fontSize={'14px'}>{numberWithSpaces(data.entry_overage?.count)}</Text> /
                        <Text className={styles.green_dark} fontSize={'16px'}>
                          {' '}
                          + {numberWithSpaces(data.entry_overage?.sum)}
                        </Text>
                      </Row>
                    </TableCell>
                    <TableCell width={WIDTH[0]} center>
                      <Row>
                        <Text fontSize={'14px'}>{numberWithSpaces(data.entry_entrying?.count)}</Text> /
                        <Text className={styles.green_dark} fontSize={'16px'}>
                          {' '}
                          + {numberWithSpaces(data.entry_entrying?.sum)}
                        </Text>
                      </Row>
                    </TableCell>
                    <TableCell width={WIDTH[0]} center>
                      <Text className={styles.green}>
                        <Row>
                          <Text className={styles.green_dark} fontSize={'16px'}>
                            {' '}
                            + {numberWithSpaces(data.extra_work?.sum)}
                          </Text>
                        </Row>
                      </Text>
                    </TableCell>
                    <TableCell width={WIDTH[0]} center>
                      <Text className={styles.red}>-{numberWithSpaces(data.penalty?.sum)}</Text>
                    </TableCell>
                    <TableCell width={WIDTH[0]} center>
                      <Text className={styles.green}>+{numberWithSpaces(data.return_penalty?.sum)}</Text>
                    </TableCell>
                    <TableCell width={WIDTH[0]} center>
                      <Text className={data.total > 0 ? styles.green : styles.red}>
                        {data.total > 0 ? '+ ' : ''}
                        {numberWithSpaces(data.total)}
                      </Text>
                    </TableCell>
                  </TableLine>
                );
              })}
          </Table>
        )}
      </WhiteBlock>

      <WhiteBlock title="Почасовая оплата" minimize={true} style={{ minWidth: '1615px' }}>
        {isOwner && (
          <Button type={TYPE_BUTTONS.GREEN} onClick={() => setOpenHourWindow(true)} style={{ marginLeft: '10px' }}>
            Добавить почасовую оплату
          </Button>
        )}

        <Table styles={styles.table}>
          <TableHeader whiteHeader>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Дата
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Процесс
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Количество часов
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Ставка
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Cумма
            </HeaderTitle>
            <HeaderTitle width={WIDTH[3]} centerText={false}>
              Описание процесса
            </HeaderTitle>
          </TableHeader>
          {extraWork
            .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
            .map((work) => {
              const data = work;

              //const data_penalty = penaltiesByDays[day];

              //    console.log('item', from, item, data);
              return (
                <TableLine key={data._id}>
                  <TableCell width={WIDTH[0]} center>
                    {getDate(work.date)}
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    {data.action_name}
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    {data.hours}
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    {data.rate}
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    <Text className={styles.green}>
                      <Row>
                        <Text className={styles.green_dark} fontSize={'16px'}>
                          + {numberWithSpaces(data.sum?.toFixed(2))}
                        </Text>
                      </Row>
                    </Text>
                  </TableCell>
                  <TableCell width={WIDTH[3]} >
                    <Text>{data.action_description}</Text>
                  </TableCell>
                  <TableCell width={WIDTH[0]} center></TableCell>
                </TableLine>
              );
            })}
        </Table>
      </WhiteBlock>

      <WhiteBlock title="Штрафы" minimize={true} style={{ minWidth: '1615px' }}>
        {isOwner && (
          <Button type={TYPE_BUTTONS.GREEN} onClick={() => setOpenRetentionWindow(true)} style={{ marginLeft: '10px' }}>
            Добавить удержание
          </Button>

        )}
        <Table styles={styles.table}>
          <TableHeader whiteHeader>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Дата штрафа
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Источник
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Номер заказа / Артикул
            </HeaderTitle>
            <HeaderTitle width={WIDTH[3]} centerText={true}>
              Описание
            </HeaderTitle>
            <HeaderTitle width={WIDTH[2]} centerText={true}>
              Фото
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Cумма
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Оспорить штраф
            </HeaderTitle>
            {isOwner && (
              <>
                <HeaderTitle width={WIDTH[0]} centerText={true}>
                  Аннуляция
                </HeaderTitle>
              </>
            )}
            <HeaderTitle width={WIDTH[3]} centerText={true}>
              Комментарий
            </HeaderTitle>
          </TableHeader>
          {penalties
            .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
            .map((penalty) => {
              const data = penalty;
              const from = data.from;
              const item = penaltyMap[data.reserve_id || data.posting_number || data.warehouse_id];
              let checkup = {};
              let artnumber_posting = '';
              let reason = '';
              if (from === 'postings') {
                artnumber_posting = penalty.posting_number;
                //console.log('postings find checkup', item.checkups);
                checkup = item.checkups?.find((ch) => ch._id === data.checkup_id);
                console.log(data, checkup);
                reason = checkup?.reason?.type;
              }
              if (from === 'reserves') {
                artnumber_posting = item.warehouse_id;
                reason = 'Проверка резервов';
              }
              if (from === 'warehouse') {
                artnumber_posting = item.id;
                reason = 'Проверка склада';
              }
              if (from === 'retention') {
                // artnumber_posting = item.id;
                reason = 'Удержание';
              }
              // console.log(data);
              return (
                <TableLine key={penalty._id}>
                  <TableCell width={WIDTH[0]} center>
                    {getDate(penalty.date)}
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    {/* {MAP_FROM[from]} */}
                    <ReasonTypeWrap reason={reason} />
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    {artnumber_posting}
                  </TableCell>
                  <TableCell width={WIDTH[3]} center>
                    {penalty.solution}
                  </TableCell>
                  <TableCell width={WIDTH[2]} center>
                    <Column>
                      <div className={styles.div_line_images}>
                        {checkup?.response?.links.slice(0, 3).map((link, index) => {
                          return (
                            <div className={styles.wrapper}>
                              <img
                                onClick={() => openImageViewer(checkup?.response?.links, index)}
                                className={styles.preview}
                                src={link.length > 0 ? link : undefined}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </Column>
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    <Column style={{ alignItems: 'center' }}>
                      <Text className={styles.red}>- {penalty.sum} ₽</Text>
                      <TextGrey fontSize={12} style={{ textAlign: 'center', fontSize: '12px' }}>
                        {penalty.sum_desc}
                      </TextGrey>
                    </Column>
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    {data.annulation?.is_annuled && (
                      <>
                        {data.annulation?.return_sum == data.sum ? (
                          <span className={styles.green}>Возврат штрафа согласован</span>
                        ) : (
                          <span className={styles.blue}>Возврат штрафа частично согласован</span>
                        )}
                      </>
                    )}
                    {data.annulation?.is_annuled === false && (
                      <span className={styles.red}>Возврат штрафа не согласован</span>
                    )}
                    {data.protest?.length > 0 && !data.annulation && (
                      <span className={styles.yellow}>На расмотрении</span>
                    )}

                    {!data.annulation && (
                      <Button
                        type={TYPE_BUTTONS.RED}
                        onClick={() => setOpenStornoWindow({ state: true, penalty: data })}
                        disabled={data.protest?.length > 0 || isOwner}
                      >
                        Оспорить штраф
                      </Button>
                    )}

                  </TableCell>
                  {isOwner && (

                    <TableCell width={WIDTH[0]} center>
                      {
                        <Button
                          type={TYPE_BUTTONS.GREEN}
                          onClick={() => {
                            changePenalty({
                              penaltyId: data._id,
                              field: 'is_annuled',
                              value: { is_annuled: !data.annulation?.is_annuled },
                            })
                          }
                          }
                        >
                          {data.annulation?.is_annuled ? 'Вернуть' : 'Аннулировать'}
                        </Button>
                      }
                    </TableCell>)}

                  <TableCell width={WIDTH[3]} center>
                    <Column>
                      <div style={{ textAlign: 'left' }}>
                        <span>Сотрудник:</span> {data.protest}
                      </div>

                      {data.annulation?.return_sum_desc?.length > 0 && (
                        <div style={{ textAlign: 'left' }}>
                          <span>Проверяющий:</span>
                          {data.annulation?.return_sum_desc}{' '}
                          {data.annulation?.is_annuled && (
                            <span>{`возврат ${data.annulation.return_sum}₽  ${getDate(
                              data.annulation?.date_annuled,
                            )}`}</span>
                          )}
                        </div>
                      )}
                    </Column>
                  </TableCell>
                  {/* && !data.annulation */}
                  {isOwner && data.protest?.length > 0 && !data.annulation && (
                    <TableCell width={WIDTH[0]} center>
                      <Button
                        type={TYPE_BUTTONS.RED}
                        onClick={() => setOpenStornoAnswerWindow({ state: true, penalty: data })}
                        disabled={data.protest?.length === 0}
                      >
                        Ответить
                      </Button>
                    </TableCell>
                  )}
                </TableLine>
              );
            })}
        </Table>
      </WhiteBlock>

      {openHourWindow && (
        <AddHourlyPayPopUp
          user={currentUser}
          close={() => {
            setOpenHourWindow(false);
            load();
          }}
        />
      )}
      {openRetentionWindow && (
        <AddRetentionPopUp
          user={currentUser}
          close={() => {
            setOpenRetentionWindow(false);
            load();
          }}
        />
      )}
      {openStornoWindow.state && (
        <DisputePenaltyPopUp
          user={currentUser}
          penalty={openStornoWindow.penalty}
          close={() => {
            setOpenStornoWindow({ state: false, penalty: {} });
            load();
          }}
        />
      )}
      {openStornoAnswerWindow.state && (
        <DisputeAnswerPenaltyPopUp
          user={currentUser}
          penalty={openStornoAnswerWindow.penalty}
          close={() => {
            setOpenStornoAnswerWindow({ state: false, penalty: {} });
            load();
          }}
        />
      )}
      {isViewerOpen && <ImageViewer src={images.links} currentIndex={images.index} onClose={closeImageViewer} />}
    </Content>
  );
}

export default PeriodFinancesPage;
